import React from 'react';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { Button as PrimeButton } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

import { toast } from 'react-toastify';

import api from '../../ApiService';

export default class Contacts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDirty: false,
            loadingContacts: true,
            loadingContactRoles: true,
            contacts: [],
            contactRoles: [],
            defaultContactRoleId: 0
        };

        this.editRoleTemplate = this.editRoleTemplate.bind(this);
        this.onIsPrimaryChange = this.onIsPrimaryChange.bind(this);
    }

    componentDidMount = async () => {
        this.props.alertContactsComponentOfHospitalChange(this.alertContactsComponentOfHospitalChange);

        this.setState({ selectedHospital: this.props.selectedHospital }, this.loadContacts);
    }

    loadContacts = async () => {
        this.setState({ loadingContacts: true });

        let contacts = await api.getContacts(this.props.selectedHospital.nameHash);
        let contactRoles = await api.getLookup("Contact Roles");
        // formatting the phone numbers
        contacts.forEach(contact => contact.phoneNumber = contact.phoneNumber
                ? this.formatPhoneNumber(contact.phoneNumber) : contact.phoneNumber);
        let defaultContactRoleId = 0;
        if (contactRoles.length > 0) defaultContactRoleId = contactRoles[0].id;

        this.setState({
            isDirty: false,
            loadingContacts: false,
            contacts,
            contactRoles,
            defaultContactRoleId
        });
    }

    alertContactsComponentOfHospitalChange = (hospital) => {
        this.setState({ selectedHospital: hospital }, this.loadContacts);
    }

    onEditorValueChange = (e) => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    formatPhoneNumber = (num) => {
        let cleanedNum = ('' + num).replace(/\D/g, '');

        return (cleanedNum.length === 10) ? `(${cleanedNum.slice(-10, -7)}) ${cleanedNum.slice(-7, -4)}-${cleanedNum.slice(-4)}`
                : (cleanedNum.length > 10) ? `+${cleanedNum.slice(0, -10)} (${cleanedNum.slice(-10, -7)}) ${cleanedNum.slice(-7, -4)}-${cleanedNum.slice(-4)}`
                : num;
    }


    onEditorBlur = (e, props) => {
        if (e.target.defaultValue === e.target.value) return;

        let items = [...props.value];
        if (items[props.rowIndex][props.field] !== e.target.value) {
            items[props.rowIndex][props.field] = e.target.value;
            this.setState({ contacts: items });
        }
    }

    onEditorKeyPress = (e, props) => {
        // have to manually handle this since onBlur doesn't make it to our control
        // 9 - tab, 13- enter
        if (e.keyCode === 9 || e.keyCode === 13) {
            this.onEditorBlur(e, props);
        }
    }

    onSelectChange = (rowIndex, field, value) => {
        let contacts = this.state.contacts.slice();
        contacts[rowIndex] = {
            ...contacts[rowIndex],
            [field]: value
        };

        this.setState({
            isDirty: true,
            contacts: contacts
        });
    }

    onIsPrimaryChange = (e, rowIndex) => {
        let contacts = this.state.contacts.slice();
        contacts[rowIndex].isPrimary = e.target.checked;

        this.setState({
            isDirty: true,
            contacts: contacts
        });
    }

    onPhoneNumberChange = (e, rowIndex) => {
        if (this.state.contacts[rowIndex].phoneNumber === e.target.value) return;
        let contacts = this.state.contacts.slice();
        contacts[rowIndex].phoneNumber = e.target.value;

        this.setState({
            isDirty: true,
            contacts: contacts
        });
    }

    addItem = () => {
        // Check to see if there is already an empty one at the end
        let canAdd = true;
        if (this.state.contacts.length > 0) {
            let lastContact = this.state.contacts[this.state.contacts.length - 1];
            canAdd = lastContact.lastName && lastContact.firstName;
        }

        if (canAdd) {
            let contacts = this.state.contacts;
            let index = contacts.length;
            contacts[index] = {
                id: 0,
                idiVetUser: this.props.selectedHospital.idiVetUser,
                lastName: '',
                firstName: '',
                phoneNumber: '',
                email: '',
                contactRoleId: this.state.defaultContactRoleId,
                isPrimary: this.state.contacts.length === 0
            };

            setTimeout(() => {
                let nodes = Array.from(document.getElementsByClassName('p-editable-column'));
                let columns = nodes.filter(div => div.innerText === '');
                columns[0].click();
            }, 200);

            this.setState({ contacts, isDirty: true });
        }
        else {
            toast.warn("Cannot add new contact until last contact is filled out.");
        }
        window.scrollTo(0, 9999);
    }

    removeItem = (e, rowData) => {
        if (rowData.index) {
            // this item was just added
            // (yes, being tricky with the var)
            var contacts = this.state.contacts.filter(x => x.index !== rowData.index);
        }
        else {
            contacts = this.state.contacts.filter(x => x.id !== rowData.id);
        }
        this.setState({ contacts, isDirty: true });
    }

    editTextTemplate = (props) => {
        return (
            <InputText type='text' defaultValue={props.rowData[props.field]}
                onBlur={(e) => this.onEditorBlur(e, props)}
                onChange={(e) => this.onEditorValueChange(e)}
                onKeyDown={(e) => this.onEditorKeyPress(e, props)}
            />
        );
    }

    editPhoneNumberTemplate = (props) => {
        let value = this.state.contacts[props.rowIndex].phoneNumber || '';
        return (
            <InputMask
                mask='(999) 999-9999'
                value={value}
                onChange={(e) => this.onPhoneNumberChange(e, props.rowIndex)}
                autoClear={false}
            />
        );
    }

    editRoleTemplate = (rowData, rowProps) => {
        let key = `contactRoleId_${rowProps.rowIndex}`;
        let value = 0;

        if (rowData.contactRoleId !== undefined && rowData.contactRoleId) {
            value = rowData.contactRoleId;
        }

        return (
            <Select disableUnderline
                style={{ minWidth: '100%' }}
                value={value}
                onChange={(event) => this.onSelectChange(rowProps.rowIndex, 'contactRoleId', event.target.value)}
                inputProps={{ name: key, id: key, key: key }}
            >
                {this.state.contactRoles.map((role, i) => {
                    return <MenuItem key={i + 1} value={role.id}>{role.name}</MenuItem>;
                })}
            </Select>
        );
    }

    editIsPrimaryTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isPrimary}
                onChange={(e) => this.onIsPrimaryChange(e, props.rowIndex)}
                value={`contacts[${props.rowIndex}].isPrimary`}
                color="primary"
            />
        );
    }

    actionTemplate = (rowData, column) => {
        return (
            <div>
                <PrimeButton type="button" icon="pi pi-trash" className="p-button-danger"
                    disabled={rowData.usage > 0} title={rowData.usage > 0 ? `Used by ${rowData.usage} hospitals.` : ''}
                    onClick={(e) => this.removeItem(e, rowData)}
                />
            </div>
        );
    }

    addButton = () => {
        return (
            <div>
                <PrimeButton type="button" icon="pi pi-plus" className="p-button-info" onClick={this.addItem} />
            </div>
        );
    }

    onClickCancel = () => {
        this.loadContacts();
        toast.success("Changes canceled.");
    }

    onClickSave = async () => {
        let success = await api.saveContacts(this.props.selectedHospital.nameHash, this.state.contacts);
        if (success) {
            // Success. Clear dirty state & reload.
            this.loadContacts();
            toast.success("Contacts updated.");
        }
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    render() {
        return (
            <div>
                <br />
                <Grid container style={{ paddingBottom: '10px' }}>
                    {this.renderSaveCancel(12)}
                </Grid>
                {this.state.loadingContacts && <em>Loading...</em>}
                {!this.state.loadingContacts &&
                    <div style={{ paddingBottom: '10px' }}>
                        <DataTable value={this.state.contacts} editable>
                            <Column field="lastName" header="Last" sortable="true" editor={this.editTextTemplate} />
                            <Column field="firstName" header="First" sortable="true" editor={this.editTextTemplate} />
                            <Column field="phoneNumber" header="Phone" sortable="true" editor={this.editPhoneNumberTemplate} />
                            <Column field="email" header="Email" sortable="true" editor={this.editTextTemplate} />
                            <Column field="contactRoleId" header="Role" sortable="true" body={this.editRoleTemplate} />
                            <Column field="isPrimary" header="Primary" sortable="true" body={this.editIsPrimaryTemplate} style={{ textAlign: 'center', width: '8em' }} />
                            <Column body={this.actionTemplate} header={this.addButton()} style={{ textAlign: 'center', width: '6em' }} />
                        </DataTable>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/Contacts.js